import { callAuthAPI } from "../axios/authAxios";

async function login(username, password) {
  const options = {
    method: "POST",
    url: "/reservation/v1/login",
    data: { username, password },
  };
  const res = await callAuthAPI(options);
  return res;
}

async function todayDonations(date) {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-today-donations",
    params: { date },
  };
  const res = await callAuthAPI(options);
  return res;
}

async function donationAmount() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-total-donation-amount",
  };
  const res = await callAuthAPI(options);
  return res;
}

async function donorAmount() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-total-donor-amount",
  };
  const res = await callAuthAPI(options);
  return res;
}

async function getAllDonations() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-donations",
  };
  const res = await callAuthAPI(options);
  return res;
}

async function updatePackage(id, data) {
  const options = {
    method: "PUT",
    url: "/reservation/v1/update-package",
    params: { package_id: id },
    data,
  };
  const res = await callAuthAPI(options);
  return res;
}

async function changeDonorStatus(donorID) {
  const options = {
    method: "PATCH",
    url: "/reservation/v1/change-donor-status",
    params: { donor_id: donorID },
  };
  const res = await callAuthAPI(options);
  return res;
}

async function getAllPackages() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-packages",
  };
  const res = await callAuthAPI(options);
  return res;
}

async function getAllInactiveDonors() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-inactive-donors",
  };
  const res = await callAuthAPI(options);
  return res;
}

async function getReservedDates() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-reserved-dates",
  };
  return await callAuthAPI(options);
}

async function updateReservedDate(data) {
  const options = {
    method: "PUT",
    url: "/reservation/v1/update-reserved-date",
    data, // should contain: reservationID, oldDate, newDate
  };
  const res = await callAuthAPI(options);
  return res;
}

async function getDonorDetails(donorID) {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-donor-details",
    params: { donor_id: donorID },
  };
  const res = await callAuthAPI(options);
  return res;
}

async function updateDonorDetails(donorID, data) {
  const options = {
    method: "PUT",
    url: "/reservation/v1/update-donor-details",
    params: { donor_id: donorID },
    data, // should contain: fullname, contactNo, whatsappNo, email, country, city, profTitle, reasonForSponsoring
  };
  const res = await callAuthAPI(options);
  return res;
}

async function sendUpdateLink(donorID) {
  const options = {
    method: "POST",
    url: "/reservation/v1/send-update-link",
    params: { donor_id: donorID },
  };
  const res = await callAuthAPI(options);
  return res;
}

async function getEmailLog() {
  const options = {
    method: "GET",
    url: "/reservation/v1/email-log",
  };
  const res = await callAuthAPI(options);
  return res;
}

async function getDonorReservations(donorID) {
  const options = {
    method: "GET",
    url: "/reservation/v1/donor-reservations",
    params: { donor_id: donorID },
  };
  const res = await callAuthAPI(options);
  return res;
}

async function updateReservationPackage(reservationId, packageId) {
  const options = {
    method: "PUT",
    url: "/reservation/v1/update-reservation-package",
    data: { reservationId, packageId },
  };
  const res = await callAuthAPI(options);
  return res;
}

async function updateReservedDatesBatch(updates) {
  const options = {
    method: "POST",
    url: "/reservation/v1/update-reserved-dates-batch",
    data: { updates },
  };
  const res = await callAuthAPI(options);
  return res;
}

const AdminDBServices = {
  login,
  todayDonations,
  donationAmount,
  donorAmount,
  getAllDonations,
  updatePackage,
  changeDonorStatus,
  getAllPackages,
  getAllInactiveDonors,
  getReservedDates,
  updateReservedDate,
  getDonorDetails,
  updateDonorDetails,
  sendUpdateLink,
  getEmailLog,
  getDonorReservations,
  updateReservationPackage,
  updateReservedDatesBatch,
};

export default AdminDBServices;
